import {
  GET_COMMISSION_LOG,
  UPDATE_COMMISSION_LOG,
  axios,
  baseURL,
} from "./types";


export const getChannelPartnerCommissionLog = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/channelpartnercommissionlog/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GET_COMMISSION_LOG,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const updateChannelPartnerCommissionLog = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/channelpartnercommissionlog/update",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATE_COMMISSION_LOG,
        payload: response.data,
      });
      return response.data;
    })
    .catch(function (error) {
      console.log(error);
      throw error;
    });
};